if (!customElements.get('sticky-product-purchase')) {
  customElements.define(
    'sticky-product-purchase',
    class StickyProductPurchase extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.nativeSubmit = this.productInfo?.querySelector('[id^="ProductSubmitButton-"]');
        this.nativePrice = this.productInfo?.querySelector('[id^="price-"]');
        this.submitButton = this.querySelector('[data-sticky-product-submit]');
        this.price = this.querySelector('[data-sticky-product-price]');

        if (!this.nativeSubmit || !this.submitButton) return;

        this.submitButton.addEventListener('click', this.handleSubmit);
        this.visibilityObserver = new IntersectionObserver(this.updateVisibility, { threshold: 0 });
        this.visibilityObserver.observe(this.nativeSubmit);
        this.stateObserver = new MutationObserver(this.syncState);
        this.stateObserver.observe(this.nativeSubmit, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });

        if (this.nativePrice) {
          this.stateObserver.observe(this.nativePrice, { childList: true, subtree: true, characterData: true });
        }

        this.syncState();
      }

      disconnectedCallback() {
        this.submitButton?.removeEventListener('click', this.handleSubmit);
        this.visibilityObserver?.disconnect();
        this.stateObserver?.disconnect();
      }

      handleSubmit = () => {
        if (this.submitButton.disabled) return;
        this.nativeSubmit.click();
      };

      updateVisibility = ([entry]) => {
        const visible = !entry.isIntersecting;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.submitButton.tabIndex = visible ? 0 : -1;
      };

      syncState = () => {
        const nativeLabel = this.nativeSubmit.querySelector('span')?.textContent?.trim();
        const stickyLabel = this.submitButton.querySelector('span');
        const unavailable = this.nativeSubmit.disabled || this.nativeSubmit.getAttribute('aria-disabled') === 'true';

        this.submitButton.disabled = unavailable;
        this.submitButton.classList.toggle('loading', this.nativeSubmit.classList.contains('loading'));
        if (nativeLabel && stickyLabel) stickyLabel.textContent = nativeLabel;
        if (this.nativePrice) this.price.textContent = this.nativePrice.innerText.trim();
      };
    }
  );
}
